import type { Ctx } from '@reatom/framework';
import { stravaAccessTokenAtom } from './strava-model';
import { StravaApiError } from './strava-api-errors';
import { ofetch } from 'ofetch';

interface StravaApiClientParams {
  method: string;
  path: string;
  accessToken: string;
  query?: Record<string, string>;
  body?: Record<string, unknown>;
  headers?: Record<string, string>;
}

type StravaApiClient = <T>(params: StravaApiClientParams) => Promise<T>;

export const getStravaClient = (ctx: Ctx): StravaApiClient => {
  const accessToken = ctx.get(stravaAccessTokenAtom);

  if (!accessToken)
    return () => Promise.reject(new StravaApiError('No access token', 401));

  return <T>(params: StravaApiClientParams) => {
    const finalQuery: string =
      params?.query && Object.keys(params.query).length
        ? `?${new URLSearchParams(params?.query)}`
        : '';
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      'content-type': 'application/json',
      ...(params?.headers ? params.headers : {}),
    };

    return ofetch<T>(
      `https://www.strava.com/api/v3${params.path}${finalQuery}`,
      {
        method: params.method,
        body: params.body,
        headers,
        async onResponseError({ request, response, options }) {
          // console.log('onResponseError', { request, response, options });

          if (response.status === 401) {
            const refreshResponse = await ofetch<{ access_token: string }>(
              '/api/strava/refresh-token',
              {
                method: 'POST',
              },
            );

            stravaAccessTokenAtom(ctx, refreshResponse.access_token);

            options.headers.set(
              'Authorization',
              `Bearer ${refreshResponse.access_token}`,
            );

            const newResponse = await ofetch<T>(request, options);

            // @ts-expect-error
            response.body = newResponse;

            // Log error
            // console.log(
            //   '[fetch response error]',
            //   request,
            //   response.status,
            //   response.body,
            // );
          }
        },
      },
    );
  };
};
